import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { LoaderComponent } from './loader.component';
import {
  EXCLUDE_URLS,
  LoaderInterceptor,
  LOADER_URLS,
} from './loader.interceptor';

export * from './loader.component';
export * from './loader.service';
export * from './loader.interceptor';
export * from './with-loader';

@NgModule({
  declarations: [LoaderComponent],
  exports: [LoaderComponent],
  imports: [CommonModule],
})
export class LoaderModule {
  static forRoot(
    config: LoaderModuleConfig
  ): ModuleWithProviders<LoaderModule> {
    return {
      ngModule: LoaderModule,
      providers: [
        { provide: LOADER_URLS, useValue: config.loaderUrls || [] },
        { provide: EXCLUDE_URLS, useValue: config.excludeUrls || [] },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: LoaderInterceptor,
          multi: true,
        },
      ],
    };
  }
}

export interface LoaderModuleConfig {
  loaderUrls?: string[];
  excludeUrls?: string[];
}
